import { AdvisingAbnormalItemFileResponse } from './../pages/advising-abnormal/interface/advising-abnormal-item-file-response';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { AdvisingAbnormalTableAbnormalItemSaveRequest } from '../pages/advising-abnormal/interface/advising-abnormal-table-abnormal-item-save-request';
import { AdvisingAbnormalTableAbnormalItemData } from '../pages/advising-abnormal/interface/advising-abnormal-table-abnormal-item-data';
import { AdvisingAbnormalTableAbnormalItemGetRequest } from '../pages/advising-abnormal/interface/advising-abnormal-table-abnormal-item-get-request';
import { AdvisingAbnormalTableDetailData } from '../pages/advising-abnormal/interface/advising-abnormal-table-detail-data';
import { AdvisingAbnormalTableHeaderData } from '../pages/advising-abnormal/interface/advising-abnormal-table-header-data';
import { AdvisingAbnormalTableHeaderGetRequest } from '../pages/advising-abnormal/interface/advising-abnormal-table-header-get-request';
import { environment } from 'src/environments/environment';
import { AdvisingAbnormalTableDetailGetRequest } from '../pages/advising-abnormal/interface/advising-abnormal-table-detail-get-request';
import { AdvisingAbnormalCreateAbnormalItemRequest } from '../pages/advising-abnormal/interface/advising-abnormal-create-abnormal-item-request';
import { AdvisingAbnormalMailRequest } from '../pages/advising-abnormal/interface/advising-abnormal-mail-request';
import { AdvisingAbnormalDialogAbnormalItemFileUpdateRequest } from '../pages/advising-abnormal/interface/advising-abnormal-dialog-abnormal-item-file-update-request';
import { AdvisingAbnormalDialogAbnormalItemFileUpdateResponse } from '../pages/advising-abnormal/interface/advising-abnormal-dialog-abnormal-item-file-update-response';
import { AdvisingAbnormalTableHeaderUpdateRequest } from '../pages/advising-abnormal/interface/advising-abnormal-table-header-update-request';
import { AdvisingAbnormalItemFilesRequest } from '../pages/advising-abnormal/interface/advising-abnormal-item-file-request';
@Injectable({
  providedIn: 'root'
})
export class AdvisingAbnormalService {

  private baseUrl: string = `${environment.logisticsApiUrl}/advisingAbnormal`;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(
    private http: HttpClient
  ) { }

  findAdvisingAbnormalHeader(headerTableGetRequest: AdvisingAbnormalTableHeaderGetRequest): Observable<PageResp<AdvisingAbnormalTableHeaderData>> {
    const url = this.baseUrl + '/findHeader';
    return this.http.post<PageResp<AdvisingAbnormalTableHeaderData>>(url, headerTableGetRequest, this.httpOptions);
  }

  findAdvisingAbnormalDetail(detailTableGetRequest: AdvisingAbnormalTableDetailGetRequest): Observable<PageResp<AdvisingAbnormalTableDetailData>> {
    const url = this.baseUrl + '/findDetail';
    return this.http.post<PageResp<AdvisingAbnormalTableDetailData>>(url, detailTableGetRequest, this.httpOptions);
  }

  findAdvisingAbnormalItem(abnormalItemTableGetRequest: AdvisingAbnormalTableAbnormalItemGetRequest): Observable<PageResp<AdvisingAbnormalTableAbnormalItemData>> {
    const url = this.baseUrl + '/findAbnormalItem';
    return this.http.post<PageResp<AdvisingAbnormalTableAbnormalItemData>>(url, abnormalItemTableGetRequest, this.httpOptions);
  }

  findFilesBySnGroup(advisingAbnormalItemFileRequest: AdvisingAbnormalItemFilesRequest): Observable<AdvisingAbnormalItemFileResponse> {
    const url = this.baseUrl + '/findAbnormalItemFiles'
    return this.http.post<AdvisingAbnormalItemFileResponse>(url, advisingAbnormalItemFileRequest, this.httpOptions);
  }

  updateHeader(updatedHeaderList: AdvisingAbnormalTableHeaderUpdateRequest): Observable<void> {
    const url = this.baseUrl + '/updateHeader'
    return this.http.post<void>(url, updatedHeaderList, this.httpOptions);
  }

  createAdvisingAbnormalItem(createAdvisingAbnormalItemRequest: AdvisingAbnormalCreateAbnormalItemRequest): Observable<void> {
    const url = this.baseUrl + '/createAbnormalItem';
    return this.http.post<void>(url, createAdvisingAbnormalItemRequest, this.httpOptions);
  }

  saveAbnormalItemChanges(saveRequest: AdvisingAbnormalTableAbnormalItemSaveRequest): Observable<void> {
    const url = this.baseUrl + '/saveAbnormalItemChanges'
    return this.http.post<void>(url, saveRequest, this.httpOptions);
  }

  updateAbnormalItemFiles(updateRequest: AdvisingAbnormalDialogAbnormalItemFileUpdateRequest): Observable<AdvisingAbnormalDialogAbnormalItemFileUpdateResponse> {
    const url = this.baseUrl + '/updateAbnormalItemFiles'
    return this.http.post<AdvisingAbnormalDialogAbnormalItemFileUpdateResponse>(url, updateRequest, this.httpOptions);
  }

  sendNotification(advisingAbnormalMailRequest: AdvisingAbnormalMailRequest, lang: string): Observable<void> {
    const url = this.baseUrl + `/sendNotification/${lang}`;
    return this.http.post<void>(url, advisingAbnormalMailRequest, this.httpOptions);
  }

  replyNotification(advisingAbnormalMailRequest: AdvisingAbnormalMailRequest, lang: string): Observable<void> {
    const url = this.baseUrl + `/replyNotification/${lang}`;
    return this.http.post<void>(url, advisingAbnormalMailRequest, this.httpOptions);
  }

}
